import { ColumnFilter } from "../../pages/ColumnFilter";
import "./Column.css";
export const COLUMNS = [
  {
    Header: "SI. #",
    accessor: "SId",
    sort: true,
    HeaderName: "SId",
    width: 70,
    minwidth: 40,
    maxwidth: 150,
    Filter: ColumnFilter,
    Img: "",
  },
  // {
  //   Header: "Course Code" ,
  //   accessor: "CourseCode",
  //   HeaderName:"CourseCode",
  //   Filter: ColumnFilter,
  //   width:180,
  //   minwidth:40,
  //   maxwidth:150,
  //   Img:<img
  //   src={process.env.PUBLIC_URL + "/images/LearningCalendar/nml-filter-icon.png"}
  //   width={60}
  //   alt='Filter-icon'
  //   className='Filter-icon'
  // />
  // },
  {
    Header: "Course Name",
    accessor: "CourseName",
    HeaderName: "CourseName",
    width: 180,
    minwidth: 40,
    maxwidth: 150,
    Img: (
      <img
        src={
          process.env.PUBLIC_URL +
          "/images/LearningCalendar/nml-filter-icon.png"
        }
        width={60}
        alt="Filter-icon"
        className="Filter-icon"
      />
    ),
  },
  // {
  //   Header: "Session Code",
  //   accessor: "SessionCode",
  //   HeaderName:"SessionCode",
  //   Filter: ColumnFilter,
  //   width:180,
  //   minwidth:40,
  //   maxwidth:150,
  //   Img:<img
  //   src={process.env.PUBLIC_URL + "/images/LearningCalendar/nml-filter-icon.png"}
  //   width={60}
  //   alt='Filter-icon'
  //   className='Filter-icon'
  // />
  // },
  {
    Header: "Start Date (YYYY-MM-DD)",
    accessor: "SessionStartDate",
    HeaderName: "SessionStartDate",
    Filter: ColumnFilter,
    width: 180,
    minwidth: 40,
    maxwidth: 150,
    Img: (
      <img
        src={
          process.env.PUBLIC_URL +
          "/images/LearningCalendar/nml-filter-icon.png"
        }
        alt="Filter-icon"
        className="Filter-icon"
      />
    ),
  },
  {
    Header: "End Date (YYYY-MM-DD)",
    accessor: "SessionEndDate",
    HeaderName: "SessionEndDate",
    Filter: ColumnFilter,
    width: 180,
    minwidth: 40,
    maxwidth: 150,
    Img: "",
  },
  {
    Header: "Duration (Hours)",
    accessor: "Duration",
    HeaderName: "Duration",
    Filter: ColumnFilter,
    width: 80,
    minwidth: 40,
    maxwidth: 150,
    Img: "",
  },
  {
    Header: "Mode of Delivery",
    accessor: "ModeofDelivery",
    HeaderName: "ModeofDelivery",
    Filter: ColumnFilter,
    width: 130,
    minwidth: 40,
    maxwidth: 130,
    Img: (
      <img
        src={
          process.env.PUBLIC_URL +
          "/images/LearningCalendar/nml-filter-icon.png"
        }
        alt="Filter-icon"
        className="Filter-icon"
      />
    ),
  },
  {
    Header: "Capability",
    accessor: "Capability",
    HeaderName: "Capability",
    Filter: ColumnFilter,
    width: 170,
    minwidth: 40,
    maxwidth: 150,
    Img: (
      <img
        src={
          process.env.PUBLIC_URL +
          "/images/LearningCalendar/nml-filter-icon.png"
        }
        alt="Filter-icon"
        className="Filter-icon"
      />
    ),
  },
  // {
  //   Header: "Nomination Count",
  //   accessor: "NominationCount",
  //   HeaderName:"NominationCount",
  //   Filter: ColumnFilter,
  //   width:120,
  //   minwidth:40,
  //   maxwidth:150,
  //   Img:""
  // },
  // {
  //   Header: "Training Host",
  //   accessor: "Traininghost",
  //   HeaderName:"Traininghost",
  //   Filter: ColumnFilter,
  //   width:120,
  //   minwidth:40,
  //   maxwidth:150,
  //   Img:""
  // },
  {
    Header: "Category",
    accessor: "Category",
    HeaderName: "Category",
    Filter: ColumnFilter,
    width: 100,
    minwidth: 40,
    maxwidth: 150,
    Img: (
      <img
        src={
          process.env.PUBLIC_URL +
          "/images/LearningCalendar/nml-filter-icon.png"
        }
        width={60}
        alt="Filter-icon"
        className="Filter-icon"
      />
    ),
  },
  {
    Header: "Workday Session Link",
    // accessor: "SessionLink",

    Cell: ({ row }) => (
      <a
        style={{ textDecoration: "none", color: "#7500c0" }}
        href={row.original.MyLearningSessionLink}
        target="_blank"
      >
        Register
      </a>
    ),
    Filter: ColumnFilter,
    width: 120,
    minwidth: 40,
    maxwidth: 150,
    Img: "",
  },
  {
    Header: "Target Audience",
    accessor: "TargetAudienceLevel",
    HeaderName: "TargetAudienceLevel",
    Filter: ColumnFilter,
    width: 120,
    minwidth: 40,
    maxwidth: 150,
    Img: (
      <img
        src={
          process.env.PUBLIC_URL +
          "/images/LearningCalendar/nml-filter-icon.png"
        }
        alt="Filter-icon"
        className="Filter-icon"
      />
    ),
  },
];
